import { render, staticRenderFns } from "./BoardingHierarchy.vue?vue&type=template&id=7068d03f&scoped=true"
import script from "./BoardingHierarchy.vue?vue&type=script&lang=js"
export * from "./BoardingHierarchy.vue?vue&type=script&lang=js"
import style0 from "./BoardingHierarchy.vue?vue&type=style&index=0&id=7068d03f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7068d03f",
  null
  
)

export default component.exports